<template>
  <div class="page_eleApplication">
    <div class="eleTltle">二维码报名</div>
    <div class="eleForm">
      <van-form @submit="onSubmit">
        <van-field v-model="name" label="姓名" required :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="PhoneNum" label="手机号" required :rules="[{ required: true, message: '请填写手机号' }]" />
        <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file"
          @change="fileChange($event)" />
        <van-field v-model="strIdCard" required label="身份证号码" right-icon="photograph" right-icon-class="photo_o"
          @click-right-icon="distinguish('#upload_file')" :rules="[{ required: true, message: '请填写身份证号码' }]" />
        <!-- <van-field v-model="strIdCard" required label="身份证号码" :rules="[{ required: true, message: '请填写身份证号码' }]" /> -->

        <input id="upload_file2" type="file" style="display: none;" accept='image/*' name="file"
          @change="fileChange2($event)" />
        <van-field v-model="Bankcard" label="银行卡号" right-icon="photograph" right-icon-class="photo_o"
          @click-right-icon="distinguish('#upload_file2')" />
        <!-- <van-field v-model="Bankcard" label="银行卡号" /> -->
        <van-field v-model="DepositBank" label="开户银行" />
        <van-field v-model="Education" required label="学历" :rules="[{ required: true, message: '请填写学历' }]" />
        <van-field v-model="Address" required label="联系地址" :rules="[{ required: true, message: '请填写联系地址' }]" />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :disabled="isSuccess || !id">{{ isSuccess ? '已完成' :
            '提交' }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
export default {
  data() {
    return {
      name: "",
      PhoneNum: "",
      strIdCard: "",
      id: "",
      Bankcard: "",
      DepositBank: "",
      Address: '',
      Education: '',
      isSuccess: false,
      isLoading: false,
    };
  },
  async created() {
    this.$store.commit("setHiddenLeft", true);
    console.log(this.$route);
    if (this.$route.query.id != undefined && this.$route.query.id) {
      this.id = this.$route.query.id;
    } else {
      this.$toast({
        duration: 4000,
        type: "fail",
        message: "扫码异常,请重新扫码",
      });
    }
  },
  methods: {
    //调用相册&相机识别
    distinguish(name) {
      $(name).click();
    },
    fileChange(el) {
      let file = $("#upload_file").get(0).files[0];
      const formData = new FormData();
      formData.append("type", 0);
      formData.append("pagename", 'Image');
      formData.append("file", file);
      console.log("formData", formData);
      xz.distinguishImg(formData).then((res) => {
        if (res.data.name != undefined) {
          this.$toast.success('识别成功，请核对');
          this.name = res.data.name;
          this.strIdCard = res.data.idCard;
          this.Address = res.data.address
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    fileChange2() {
      let file = $("#upload_file2").get(0).files[0];
      const formData = new FormData();
      formData.append("type", 1);
      formData.append("pagename", 'Image');
      formData.append("file", file);
      console.log("formData", formData);
      xz.distinguishImg(formData).then((res) => {
        if (res.data.no != undefined) {
          this.$toast.success('识别成功，请核对');
          // this.DepositBank = res.data.name;
          this.Bankcard = res.data.no;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    getImgInfo() {
      xz.distinguishImg();
    },
    onSubmit() {
      if (!this.isLoading) {
        this.isLoading = true;
        xz.SubmitEcon(
          this.name,
          this.PhoneNum,
          this.strIdCard,
          this.id,
          this.Bankcard,
          this.Address,
          this.Education,
          this.DepositBank
        ).then((res) => {
          if (res.status == "ok") {
            this.$toast({
              duration: 5000,
              type: "success",
              message: "保存成功"
            });
            this.isSuccess = true;
          } else {
            setTimeout(() => {
              this.isLoading = false;
            }, 2000);
            this.$toast.fail(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.page_eleApplication {
  background: #fff;
  min-height: 100vh;
}

.eleTltle {
  font-weight: 600;
  font-size: 17px;
  text-transform: capitalize;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: #fff;
  text-align: center;
}

.eleForm {
  /* background: #fff; */
  padding: 20px 0;
}
</style>
<style>
.page_eleApplication .van-icon-photograph:before {
  font-size: 26px;
}
</style>